<span class="msa-toast__icon" aria-hidden="true">{{ icon() }}</span>
<span class="msa-callout__content">
  @if (title()) {
    <strong class="msa-callout__title">{{ title() }}</strong>
  }
  {{ message() }}
</span>
@if (dismissible()) {
  <lib-button
    class="msa-toast__close"
    icon="✕"
    variant="ghost"
    color="neutral"
    size="sm"
    label="Cerrar"
    (clicked)="onDismiss()"
  />
}
@if (duration() > 0) {
  <span class="msa-toast__progress" [style.animation-duration.ms]="duration()"></span>
}
